import React from 'react';

type CustomDateInputProps = {
  value?: string;
  onClick?: () => void;
  placeholder?: string;
  icon?: React.ReactNode;
  isRTL?: boolean;
};

const CustomDateInput = React.forwardRef<HTMLInputElement, CustomDateInputProps>(
  ({ value, onClick, placeholder, icon, isRTL }, ref) => (
    <div className="relative w-full">
      <input
        type="text"
        value={value}
        onClick={onClick}
        placeholder={placeholder}
        className={`w-full bg-gray-300 text-textSecond rounded-lg border border-gray-300 px-1 py-2 focus:outline-none ${
          icon ? (isRTL ? 'pr-10' : 'pl-10') : ''
        }`}
        readOnly
        ref={ref}
      />
      {icon && (
        <div
          className={`absolute inset-y-0 flex items-center text-primary ${
            isRTL ? 'right-3' : 'left-3'
          }`}
        >
          {icon}
        </div>
      )}
    </div>
  )
);

export default CustomDateInput;